import { tns } from 'tiny-slider/src/tiny-slider';

class SideTabsSlider {
	constructor(el, prevButton, nextButton, nav) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;
		this.nav = nav;
		this.instance = null;
		this.observer = null;

		this.waitForActive();
	}

	waitForActive = () => {
		const container = this.el.closest('.block-side-tabs__tab-content-container');

		if (!container) return;

		if (container.classList.contains('active')) {
			this.init();
			return;
		}

		this.observer = new MutationObserver(() => {
			if (container.classList.contains('active') && !this.instance) {
				this.init();
				this.observer.disconnect();
			}
		});

		this.observer.observe(container, { attributes: true, attributeFilter: ['class'] });
	};

	init = () => {
		const hasNav = this.prevButton && this.nextButton && this.nav;

		this.instance = tns({
			container: this.el,
            items: 1,
	        slideBy: 1,
			autoplay: false,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: hasNav,
			prevButton: this.prevButton || null,
			nextButton: this.nextButton || null,
			nav: hasNav,
			navPosition: 'bottom',
			navContainer: this.nav || null
		});

		this.enableControlsFocus();

		this.instance.events.on('indexChanged', this.enableControlsFocus);
		this.instance.events.on('transitionEnd', this.enableControlsFocus);
	};

	enableControlsFocus = () => {
		setTimeout(() => {
			[this.prevButton, this.nextButton].forEach((button) => {
				if (!button) return;

				button.disabled = false;
				button.removeAttribute('disabled');
				button.removeAttribute('tabindex');
				button.setAttribute('tabindex', '0');
				button.removeAttribute('aria-hidden');
			});
		}, 0);
	};
}

export default SideTabsSlider;